module.exports = __webpack_public_path__ + "img/welcomes-preview-current-all-white.4048c3dc.png";